import actions from './actions'

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/features/payer_assignors/store/index.js